import { render, staticRenderFns } from "./compact-link.vue?vue&type=template&id=6e9c68a2&"
import script from "./compact-link.vue?vue&type=script&lang=js&"
export * from "./compact-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports